/* prettier-ignore */

import { Component, ElementRef, inject, Input, signal, ViewChild, ViewEncapsulation } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { GoogleMapsPlacesComponent } from 'src/app/shared/google-maps-places/google-maps-places.component';
import { IonicModule, ModalController } from '@ionic/angular';
import { PRIMARY_TIMELINE_COLORS } from '../../constants';

@Component({
  selector: 'add-custom-location',
  imports: [CommonModule, TranslateModule, GoogleMapsPlacesComponent, IonicModule],
  standalone: true,
  templateUrl: './add-custom-location.component.html',
  styleUrls: ['./add-custom-location.component.scss'],
  encapsulation: ViewEncapsulation.Emulated
})

export class AddCustomLocationComponent {
    @Input("arrayDays") arrayDays: any;
    @ViewChild("daysContainer", { static: false }) daysContainer!: ElementRef;
    private modalControllet = inject(ModalController);
    public arrayColors = PRIMARY_TIMELINE_COLORS;
    public selectedDay = signal(null);
    private locationForm: any;

    selectDay(day){
      this.selectedDay.set(day);
    }

    checkWidth(){
      return this.daysContainer?.nativeElement?.scrollWidth > this.daysContainer?.nativeElement?.clientWidth;
    }

    goLeft(){
      if (!this.daysContainer?.nativeElement) return;
      this.daysContainer.nativeElement.scrollLeft -= 75
    }

    goRight(){
      if (!this.daysContainer?.nativeElement) return;
      this.daysContainer.nativeElement.scrollLeft += 75
    }

    closeModal(){
      this.modalControllet.dismiss();
    }

    confirm(type){
      if (!this.locationForm) return;
      if (!this.selectedDay())
        this.selectedDay.set('all')
      
      this.modalControllet.dismiss({
        day: this.selectedDay(),
        type: type,
        location: this.locationForm
      });
    }

    getLocation(location){
      this.locationForm = location;
    }

}